
import { DiaryGeneratorParams } from './types';
import {
  generateIntroduction,
  generateActivitiesContent,
  generateMilestonesContent,
  generateMetricsContent,
  generateConclusion
} from './generators';

export function generateDiaryEntry(params: DiaryGeneratorParams): string {
  const { 
    babyName, 
    age, 
    activities, 
    milestones, 
    mood, 
    additionalNotes,
    height,
    weight,
    diaperChanges,
    milkIntake
  } = params;
  
  const introduction = generateIntroduction(babyName, mood);
  
  const activitiesContent = generateActivitiesContent(babyName, activities);
  const milestonesContent = milestones.length > 0 
    ? generateMilestonesContent(babyName, milestones) 
    : '';
  
  const metricsContent = generateMetricsContent(babyName, height, weight, diaperChanges, milkIntake);
  
  const conclusion = generateConclusion(babyName, age);
  
  const notesContent = additionalNotes 
    ? `\n\nSpecial note: ${additionalNotes}` 
    : '';
  
  return `${introduction}\n\n${activitiesContent}${milestonesContent}${metricsContent}\n\n${conclusion}${notesContent}`;
}
